import { render, staticRenderFns } from "./PrintDocuments.vue?vue&type=template&id=2220d4e2&scoped=true&"
import script from "./PrintDocuments.vue?vue&type=script&lang=js&"
export * from "./PrintDocuments.vue?vue&type=script&lang=js&"
import style0 from "./PrintDocuments.vue?vue&type=style&index=0&id=2220d4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220d4e2",
  null
  
)

export default component.exports